import React, { useState } from "react";
import {
  Box,
  VStack,
  HStack,
  Button,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import AgentTable from "../../components/eva/AgentTable";
import ToolTable from "../../components/eva/ToolTable";


const EvaListPage: React.FC = () => {
  const navigate = useNavigate();

  // Tab state
  const [activeTab, setActiveTab] = useState(0);

  const handleCreate = () => {
    navigate("/old-eva/agent/create");
  };

  return (
    <Box className="eva-list-container eva-small-scrollbar">
      <VStack className="eva-list-content" spacing={6}>
        {/* Header with create button */}
        <HStack justify="space-between" w="full">
          <Heading size="m">Agents & Tools Management</Heading>
          <Button onClick={handleCreate} colorScheme="blue" size="sm">
            Create Agent
          </Button>
        </HStack>

        {/* Tabs for Agents and Tools */}
        <Tabs index={activeTab} onChange={setActiveTab} w="full" variant="enclosed">
          <TabList>
            <Tab>Agents</Tab>
            <Tab>Tools</Tab>
          </TabList>

          <TabPanels>
            {/* Agents Tab */}
            <TabPanel px={0}>
              <AgentTable />
            </TabPanel>

            {/* Tools Tab */}
            <TabPanel px={0}>
              <ToolTable />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>
    </Box>
  );
};

export default EvaListPage;
